import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { GeoLocation, GeoLocationMetaData } from 'types/User/Cookie'
import { getGeoLocation, getGeoLocationMetaData } from 'selectors/user/cookie'

const mapStateToProps = createStructuredSelector({
  geoLocation: getGeoLocation,
  geoLocationMetaData: getGeoLocationMetaData,
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  geoLocation: GeoLocation
  geoLocationMetaData: GeoLocationMetaData
}

export default connect(mapStateToProps, mapDispatchToProps)
